// src/pages/StripeRefresh.js

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createAccountLink } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { Container, Typography, CircularProgress, Box, Snackbar, Alert, Button } from '@mui/material';

function StripeRefresh() {
    const navigate = useNavigate();
    const { currentUser, loading: authLoading } = useAuth();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    useEffect(() => {
        const refreshAccountLink = async () => {
            try {
                if (currentUser && currentUser.stripe_connected_account_id) {
                    const response = await createAccountLink();
                    const accountLinkUrl = response.data.url;
                    window.location.href = accountLinkUrl;
                } else {
                    setError('Stripe account is not connected.');
                }
            } catch (err) {
                console.error('Error creating account link:', err);
                setError('Failed to refresh Stripe onboarding. Please try again.');
            } finally {
                setLoading(false);
            }
        };

        if (!authLoading) {
            refreshAccountLink();
        }
    }, [currentUser, authLoading]);

    const handleGoBack = () => {
        navigate('/profile');
    };

    if (loading) {
        return (
            <Container maxWidth="sm">
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
                    <CircularProgress />
                </Box>
            </Container>
        );
    }

    return (
        <Container maxWidth="sm">
            <Box textAlign="center" mt={5}>
                <Typography variant="h5" gutterBottom>
                    Refresh Stripe Onboarding
                </Typography>
                {error ? (
                    <>
                        <Typography variant="body1" color="error" gutterBottom>
                            {error}
                        </Typography>
                        <Button variant="contained" color="primary" onClick={handleGoBack}>
                            Go to Profile
                        </Button>
                    </>
                ) : (
                    <Typography variant="body1" gutterBottom>
                        Redirecting to Stripe for onboarding...
                    </Typography>
                )}
            </Box>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
            >
                <Alert
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Container>
    );
}

export default StripeRefresh;
